import React, { useContext, useState } from 'react';
import { View, Pressable } from 'react-native';
import styled from 'styled-components/native';

import Ticket from 'app/src/components/Ticket';
import ClientContext from 'app/src/contexts/ClientContext';
import { Text } from 'app/src/styles';
import colors from 'app/src/styles/colors';
import ExternalLink from 'app/src/elements/ExternalLink';

const Container = styled(View)`
  background-color: ${colors.header};
  min-height: 90px;
  padding: 20px;
  padding-left: 40px;
`;

const FooterText = styled(Text)`
  color: white;
  font-size: 16px;
  margin-bottom: 6px;
`;

const Links = styled(View)`
  flex-direction: row;
  justify-content: space-between;
`;

const Footer = () => {
  const { isMobile } = useContext(ClientContext);
  const [showTicket, setShowTicket] = useState(false);

  return (
    <Container>
      {isMobile ? (
        <>
          <FooterText>service@oklahomatemptag.com</FooterText>
          <FooterText>918-525-1105</FooterText>
        </>
      ) : (
        <FooterText>
          813 NW 34th St, Moore, OK 73160{' · '}
          service@oklahomatemptag.com{' · '}
          918-525-1105
        </FooterText>
      )}

      <Links>
        <View style={{ flexDirection: 'row', gap: 24 }}>
          <ExternalLink url="/privacy" target="_self">
            <FooterText>Privacy Policy</FooterText>
          </ExternalLink>
          <ExternalLink url="/terms" target="_self">
            <FooterText>{isMobile ? 'Terms' : 'Terms & Conditions'}</FooterText>
          </ExternalLink>
        </View>
        <Pressable onPress={() => setShowTicket(true)}>
          <FooterText>Provide Feedback</FooterText>
        </Pressable>
      </Links>

      {showTicket && (
        <Ticket setShow={setShowTicket} />
      )}
    </Container>
  );
};

export default Footer;
